<template>
  <div> 
    <video autoplay muted loop>
      <source src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1744893076018-6/BJ03.mp4.mp4" type="video/mp4">
      你的浏览器不支持视频播放。
  </video>
  <!-- 相框和照片 -->
  <div class="photo-frame">
      <!-- <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20250319/user-0/20250319/f618e29340a685b59dc472af38cae01f.jpg?x-oss-process=style/tb-750" -->
      <img :src="start.heying"
          alt="Team Photo">
  </div>
  <div class="content">
      <div class="team-name">{{start.mingcheng}}</div>
      <div class="slogan">{{start.kouhao}}</div>
  </div>
  </div>
</template>
<style scoped> 
        body {
            margin: 0;
            padding: 0;
            overflow: hidden;
        }

        video {
            position: fixed;
            top: 50%;
            left: 50%;
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            z-index: -100;
            transform: translateX(-50%) translateY(-50%);
            background-size: cover;
            transition: 1s opacity;
            filter: blur(5px);
        }

        /* 相框样式 */
        .photo-frame {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.1) rotate(-360deg);
            opacity: 0;
            width: 60%;
            max-width: 600px;
            border: 20px solid #e0e0e0;
            border-radius: 20px;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
            animation: floatIn 3s ease-out forwards;
            z-index: 1;
        }

        /* 相框内照片样式 */
        .photo-frame img {
            width: 100%;
            height: auto;
            display: block;
        }

        /* 照片飘入动画 */
        @keyframes floatIn {
            0% {
                transform: translate(-50%, -50%) scale(0.1) rotate(-360deg);
                opacity: 0;
            }
            50% {
                transform: translate(-50%, -50%) scale(0.8) rotate(0deg);
                opacity: 1;
            }
            100% {
                transform: translate(-50%, -50%) scale(1) rotate(0deg);
                opacity: 1;
            }
        }

        .content {
            position: relative;
            z-index: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
            font-family: Arial, sans-serif;
        }

        .team-name,
        .slogan {
            opacity: 0;
            transition: opacity 1s ease, transform 1s ease, font-size 2s ease 1s, color 4s ease; /* 颜色过渡时间调整为 4 秒 */
            text-shadow: 0 0 10px white; /* 白色外发光效果 */
            -webkit-text-stroke: 1px white; /* 白色文字笔画边框 */
            color: #fff7b2; /* 设置初始颜色 */
        }

        .team-name {
            font-size: 48px;
            font-weight: bold;
            margin-bottom: 500px;
            text-align: center;
            transform: translate(100%, -100%);
        }

        .slogan {
            font-size: 32px;
            transform: translate(-100%, 100%);
        }

        .team-name.show {
            opacity: 1;
            transform: translate(0, 0);
            font-size: 96px; /* 确保文字变大到原来的 2 倍 */
        }

        .slogan.show {
            opacity: 1;
            transform: translate(0, 0);
            font-size: 64px; /* 确保文字变大到原来的 2 倍 */
        }
    </style>

</style>
<script>
  
export default {
  name: "ScoreStartArmyPro",
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    start: {
      type: Object,
      default: () => {}
    },
    list:{
      type: Array,
      default: []
    }
  },
  components: {},
  data() {
    return {
      scoreList: [], 
      colors : ['#8bc34a', '#fff7b2', '#d2f5fa'],
      currentColorIndex : 0,
      formData: {
        id: 0
      },
      thisIndex:0,

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      clientHeight: 0
    }

  },
  watch:{
    list(){ 
      let that = this
      console.log('watch list')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    },
    start(){ 
      let that = this
      console.log('watch start')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    }
  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '队伍信息'
    this.init()
  },
  destroyed() {
    console.log('destroyed')
  },
  computed: {},
  methods: {
    changeColor() {
          const teamName = document.querySelector('.team-name');
          const slogan = document.querySelector('.slogan');

          teamName.style.color = this.colors[this.currentColorIndex];
          slogan.style.color = this.colors[this.currentColorIndex];

          this.currentColorIndex = (this.currentColorIndex + 1) % this.colors.length;

          setTimeout(this.changeColor, 4000); // 每 4 秒切换一次颜色
      },
    init(){
      let that = this

      setTimeout(() => {
                document.querySelector('.team-name').classList.add('show');
            }, 3500); // 等待照片动画完成后显示团队名称
      setTimeout(() => {
          document.querySelector('.slogan').classList.add('show');
      }, 4500); // 稍晚显示口号

      setTimeout(this.changeColor, 5000); // 等待照片和文字显示后开始颜色切换
    }
  }
}
</script>



// WEBPACK FOOTER //
// ScoreStartArmyPro.vue?4fa3caea